import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { PropertyRoomOption } from "~/models/PropertyRoomOption";

const paths = {
	index: "/property_room_options"
} as const;

type TIndex = (
	name: string | null,
	address: string | null,
	buildingPropertyId: number | null
) => SwrReturnType<PropertyRoomOption[]>;

type ReturnType = {
	index: TIndex;
};

export const usePropertyRoomOptions = (): ReturnType => {
	const index: TIndex = (
		name: string | null,
		address: string | null,
		amaterasBuildingPropertyId: number | null
	) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error, isValidating } = useSWR(
			name && address
				? {
						params: { address, amaterasBuildingPropertyId, name },
						url: paths.index
					}
				: null
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			isValidating,
			mutate: mutate ?? null
		};
	};
	return { index };
};
